import { ComplexEnum } from '../../utils/complexEnum'
import {
  WeeklyFrequencyItem,
  DailyFrequencyItem,
  MinuteFrequencyItem,
  HourlyFrequencyItem,
} from './instances'

export type FrequencyItem =
  | typeof MinuteFrequencyItem
  | typeof HourlyFrequencyItem
  | typeof DailyFrequencyItem
  | typeof WeeklyFrequencyItem

class FrequencyItemEnum extends ComplexEnum<
  'FrequencyItem',
  FrequencyItem,
  FrequencyItem['id']
> {
  readonly typename = 'FrequencyItem'
  get values() {
    return [
      this.MinuteFrequencyItem,
      this.HourlyFrequencyItem,
      this.DailyFrequencyItem,
      this.WeeklyFrequencyItem,
    ]
  }
  readonly MinuteFrequencyItem = MinuteFrequencyItem
  readonly HourlyFrequencyItem = HourlyFrequencyItem
  readonly DailyFrequencyItem = DailyFrequencyItem
  readonly WeeklyFrequencyItem = WeeklyFrequencyItem
}

export const FrequencyItem = new FrequencyItemEnum()
